import EventScope from 'owa-service/lib/contract/EventScope';
import { getCalendarViewEventRouteParams } from 'mini-mail-reading-pane-store/lib/store/selectors/getCalendarViewEventRouteParams';

export const getCalendarEventViewRoutePath = (): string[] => {
    const route: string[] = [];
    const {
        eventId,
        scope = `${EventScope.Default}`,
        spokeType,
        routeIdType,
        routeId,
        view,
        isEdit,
    } = getCalendarViewEventRouteParams();

    if (!eventId) {
        return [];
    }
    route.push('event', eventId);

    if (isEdit) {
        route.push('edit', scope);
    } else {
        route.push('details');
    }

    if (![undefined, null].includes(spokeType)) {
        route.push('spoke', spokeType);
        !isEdit && route.push(scope);
    }

    if (routeIdType ?? routeId) {
        route.push('card', routeIdType, routeId, view);
    }

    return route;
};
